import React, { ReactNode } from 'react';
import styles from '../../styles.module.css';
import { categoryType, productCardType, ProductImage } from '@/commonTypes';
import AppImage from '@/components/common/AppImage';

export default function ProductMedia({
  children,
  showAfter,
  className = '',
  style = {},
  data,
  showImage = true,
}: {
  children?: ReactNode;
  showAfter?: boolean;
  className?: string;
  style?: any;
  data?: { media?: ProductImage[]; category?: categoryType };
  showImage?: boolean;
}) {
  return (
    <div className={`${styles.pcard_media} ${className}`} style={style}>
      <div
        className={`${styles.ph} ${showAfter && styles.showAfter}`}
        data-label={data?.category?.title}
      >
        {data?.media?.[0]?.name && showImage ? (
          <AppImage
            src={data?.media?.[0]?.name}
            className={`${styles.image}`}
            containerclassName={`${styles.imageContainerClassName}`}
          />
        ) : (
          <div className={`${styles.glyph}`}></div>
        )}
      </div>
      {children}
    </div>
  );
}
